import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { CartService } from '../cart/cart.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  // tslint:disable-next-line: max-line-length
  // https://gmrapi.scandid.in/api/getFoodMenu?key=qw1op5cv8j0d&pid=gmr&deviceid=ef1c1390f0c37d26&platform=android&storeid=1966&type=food_items&location_id=3276&airportid=5540
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    // baseUrl: 'http://a.gmr.in',
    path: '/api/getFoodMenu'
  };
  apiParams: any;

  // tslint:disable-next-line: max-line-length
  constructor(private httpClient: HttpClient, private helperService: HelperService, private cartService: CartService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  public get menuServiceApi(): string {
    // tslint:disable-next-line: max-line-length
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    return this.menuServiceApi = `${this.envService.getFoodMneuApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set menuServiceApi(value: string) {
  }

  initApiParams() {
    this.apiParams = {
      type: 'food_items',
      location_id: null,
      storeid: null,
    };
  }

  getMenuList(locationId, storeId) {
    if (this.cartService.guestDeviceId !== null) {
      this.apiParams.deviceid = this.cartService.guestDeviceId;
    }
    if (this.cartService.guestId !== null) {
      this.apiParams.guestid = this.cartService.guestId;
    }
    this.apiParams.location_id = locationId;
    this.apiParams.storeid = storeId;
    return this.httpClient.get<any>(this.menuServiceApi);
  }
}
